/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { classNames } from '@ember-decorators/component';

@classNames('layout-row')
export default class PostSurveyRow extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  // Services
  @service
  paperToaster;

  @service
  session;

  @service
  store;

  // Properties
  @tracked
  selectedAnswer = '';

  @tracked
  isEditing = false;

  // Attributes
  response = null;

  onChange() {}

  @computed(
    'learner.{id,firstName}',
    'session.personId',
    'response.{createTime,updateTime}',
  )
  get label() {
    let parts = [];
    if (this.get('learner.id') === this.get('session.personId')) {
      // This is a learner, so don't show their name.
      parts.push('My answer');
    } else {
      parts.push(this.get('learner.firstName'));
    }
    if (!isEmpty(this.response)) {
      let timestamp = this.get('response.createTime');
      if (this.get('response.updateTime')) {
        timestamp = this.get('response.updateTime');
      }
      if (!isEmpty(timestamp)) {
        let formatted = moment.unix(timestamp).format('D MMM YYYY');
        parts.push(`(answered on ${formatted})`);
      }
    }
    return parts.join(' ');
  }

  // newLabel is displayed in the v2 style under the survey
  @computed(
    'learner.{id,firstName}',
    'session.personId',
    'response.{createTime,updateTime}',
  )
  get newLabel() {
    if (isEmpty(this.response)) {
      // Return the child's name if it's not answered for
      return this.get('learner.firstName');
    }
    let string = 'Answered';

    if (this.get('learner.id') === this.get('session.personId')) {
      // This is a learner, so don't show their name.
      string += ' by me';
    } else {
      string += ' for ' + this.get('learner.firstName');
    }
    if (!isEmpty(this.response)) {
      let timestamp = this.get('response.createTime');
      if (this.get('response.updateTime')) {
        timestamp = this.get('response.updateTime');
      }
      if (!isEmpty(timestamp)) {
        let formatted = moment.unix(timestamp).format('D MMM YYYY');
        string += ` on ${formatted}`;
      }
    }
    return string;
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    if (!isEmpty(this.response)) {
      this.selectedAnswer = this.get('response.answer');
    }
  }

  @action
  async changeAnswer(newAnswer) {
    // Each branch assigns the save promise. A rejected placeholder here would
    // be unhandled during the await below.
    let promise;
    let response;
    if (this.response) {
      // Updating an existing response.
      this.response.setProperties({
        answer: newAnswer,
        author: this.get('session.person'),
      });
      promise = this.response.save();
      response = this.response;
    } else {
      // Adding a new answer.
      let newResponse = {
        authorId: this.get('session.personId'), // Just the ID - not the entity itself.
        // A belongsTo takes a record, not the async proxy.
        schoolId: await this.get('survey.school'),
        surveyId: await this.survey,
        personId: this.learner,
        answer: newAnswer,
      };
      response = this.store.createRecord('surveys/response', newResponse);
      promise = response.save();
    }

    promise
      .then(() => {
        this.paperToaster.show(`Survey response saved successfully.`, {
          duration: 4000,
          position: 'top right',
          toastClass: 'success',
        });
        // Finish editing the response and collapse the survey
        this.isEditing = false;
        this.onChange();
      })
      .catch(() => {
        this.paperToaster.show(
          `Oops, we couldn't save that.  This survey may have already been answered.`,
          {
            duration: 8000,
            position: 'top right',
            // NOTE: Not using [toastClass: 'warning'] deliberately, to make it less "angry" for parents/students.
          },
        );
        response.rollbackAttributes();

        // We may have failed because somebody else has entered a response which we haven't yet retrieved.
        // Trigger a reload to see if we get a record for it.
        this.onChange();
      });
  }
}
